import React from 'react';
import './NotFoundPage.css';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../common/Routing/Routes'; // Підлаштуйте шлях під ваш проект
import { Button } from '@mui/material';

function NotFoundPage() {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate(ROUTES.HOME);
    };

    return (
        <div className='not-found'>
            Щоб ви не шукали, але цього немає, нажаль.
            <div style={{ marginTop: '20px' }}>
                <Button
                    variant="outlined"
                    sx={{ flex: 1 }}
                    onClick={handleGoHome}
                >
                    На головну
                </Button>
            </div>
        </div>
    );
}

export default NotFoundPage;
